import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2695a6ae"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "about"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("header", {
  class: "header"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "main"
}, [/*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, "关于我们")])], -1));
import AboutUs from './components/about-us';
import Expert from './components/expert';
import Qualifications from './components/qualifications';
import Development from './components/development';
import { onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { scrollToAnchor } from '@/utils';
export default /*#__PURE__*/_defineComponent({
  __name: 'about',
  setup(__props) {
    const $route = useRoute();
    onMounted(() => {
      const anchor = $route.query.anchor;
      if (anchor) {
        scrollToAnchor('#' + anchor);
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_unref(AboutUs)), _createVNode(_unref(Development)), _createVNode(_unref(Qualifications)), _createVNode(_unref(Expert))]);
    };
  }
});